import {authService} from "../../client/connection/services/AuthService.js";
import {WebsiteIndex} from "./WebsiteIndex.jsx";
import type {RouteRedirect, RouteSnapshot} from "../../stem-core/ui/Router";

const options = {replaceHistory: true};

// TODO @cleanup these should just be plain functions
export class AppGuards {
    static checkNotAuthenticated(): RouteRedirect | null {
        if (!authService.isAuthenticated()) {
            return null;
        }
        return ["/wallet", options];
    }

    static checkAuthenticated(routeSnapshot: RouteSnapshot): RouteRedirect | null {
        if (authService.isAuthenticated()) {
            return null;
        }
        WebsiteIndex.setRedirectURL(routeSnapshot.path);
        return ["/", options];
    }
}
